<template>
<div>
  <Grid name="filterGridProduct" ref="filterGridProduct" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import kendo from '@progress/kendo-ui/js/kendo.all.js'
export default {
  name: 'Product',
  props: ['height'],
  components: {
    Grid
  },
  data() {
    return {
      preload: [{
        field: 'core_id',
        api: 'cores/lst'
      }, {
        field: 'brand_id',
        api: 'brands/lst'
      }, {
        field: 'mpg_id',
        api: 'mpgs/lst'
      }, {
        field: 'product_aggregator_id',
        api: 'prodagregs/lst'
      }],
      schemaModelFields: {},
      url: 'products',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'sku',
        title: 'Sku'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'product_aggregator_id',
        title: 'ProdAgreg',
        width: '200px'
      }, {
        field: 'core_id',
        title: 'Core',
        width: '200px'
      }, {
        field: 'brand_id',
        title: 'Brand',
        width: '200px'
      }, {
        field: 'mpg_id',
        title: 'Mpg',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    }
  },
  methods: {
    addIncludeFilter(e) {
      e.preventDefault()
      var grid = this.$refs.filterGridProduct.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('added-filter', {
        field: 'product_id',
        item: dataItem,
        title: 'Product',
        'type': 'includes'
      })
    },
    addExpurgeFilter(e) {
      e.preventDefault()
      var grid = this.$refs.filterGridProduct.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('added-filter', {
        field: 'product_id',
        item: dataItem,
        title: 'Product',
        'type': 'expurges'
      })
    },
    addExcludeFilter(e) {
      e.preventDefault()
      var grid = this.$refs.filterGridProduct.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('added-filter', {
        field: 'product_id',
        item: dataItem,
        title: 'Product',
        'type': 'excludes'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProductFilter.vue?188c8cec